import { clearGeo } from './clearGeo';
import { getGeoValue, setGeo } from './helpers';
import { TJsonQuery } from './types';

export function clearGeoLocation(locationId: number) {
  return (jsonQuery: TJsonQuery) => () => {
    const geo = getGeoValue()(jsonQuery);

    if (!geo) {
      return jsonQuery;
    }

    const nextGeo = geo?.filter(
      item => item.type !== 'location' || (item.type === 'location' && item.id !== locationId),
    );

    return nextGeo.length ? setGeo()(jsonQuery)(nextGeo) : clearGeo(jsonQuery)();
  };
}
